export default {
  imprintColors: [
    {
      label: "White",
      value: "#FFFFFF"
    },
    {
      label: "Black",
      value: "#000000"
    },
    {
      label: "Athletic Gold",
      value: "#FFC72C"
    },
    {
      label: "Brown",
      value: "#5B3427"
    },
    {
      label: "Burgundy",
      value: "#6C1D45"
    },
    {
      label: "Dark Green",
      value: "#284734"
    },
    {
      label: "Gray",
      value: "#7C878E"
    },
    {
      label: "Kelly Green",
      value: "#00843D"
    },
    {
      label: "Metalic Gold",
      value: "#85714D"
    },
    {
      label: "Navy Blue",
      value: "#041E42"
    },
    {
      label: "Orange",
      value: "#FE5000"
    },
    {
      label: "Pink",
      value: "#F57EB6"
    },
    {
      label: "Purple",
      value: "#5F259F"
    },
    {
      label: "Red",
      value: "#C8102E"
    },
    {
      label: "Royal Blue",
      value: "#0033A0"
    },
    {
      label: "Sliver",
      value: "#8A8D8F"
    },
    {
      label: "Teal",
      value: "#009CA6"
    },
    {
      label: "Vegas Gold",
      value: "#998542"
    },
    {
      label: "Yellow",
      value: "#FFD700"
    },
    {
      label: "Process Blue",
      value: "#0085CA"
    },
    {
      label: "Reflex Blue",
      value: "#001489"
    }
  ]
};
